import { render } from "./Estado.vue?vue&type=template&id=198e1163&scoped=true"
import script from "./Estado.vue?vue&type=script&lang=js"
export * from "./Estado.vue?vue&type=script&lang=js"

import "./Estado.vue?vue&type=style&index=0&id=198e1163&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Usuario\\Desktop\\prueba\\Blooz\\blooz\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-198e1163"]])

export default __exports__